import Image from "next/image";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { AuthModalHeaderLogoContainer } from "./styles";

const AuthModalHeaderLogo = () => {
  const { state } = useGlobalContext();

  const { settings } = state.tenancy;

  const users = settings?.users;
  const site = settings?.site;

  const isDarkMode = state.theme.value === "dark";

  const theme = settings?.["general-theme"];
  const loginImage = users?.userLoginRequiredImage;
  const defaultImage = theme?.themeLogoHorizontal;
  const fallbackImage = theme?.themeLogoTopBar;
  const loginImageStatus = users?.userLoginImage;

  const platformHasNoImage = !defaultImage && !fallbackImage;

  const logoSrc = isDarkMode
    ? theme?.themeDarkModeLogoHorizontal || defaultImage
    : loginImageStatus === "default"
    ? defaultImage
    : defaultImage || fallbackImage || loginImage;

  return (
    <AuthModalHeaderLogoContainer>
      {loginImageStatus === "none" || platformHasNoImage ? (
        <h1 className="auth-modal-header-logo-title">{site?.siteName}</h1>
      ) : (
        <Image
          src={logoSrc}
          width={280}
          height={58}
          quality={40}
          alt="logo"
          className="auth-modal-logo"
        />
      )}
    </AuthModalHeaderLogoContainer>
  );
};

export default AuthModalHeaderLogo;
